export enum MenuItemType {
  RouterLink = 'routerLink',
  Href = 'href',
}
